import cx from 'classnames'

import styles from '../storefronts.module.scss'

type Props = React.PropsWithChildren<{
  className?: string | string[]
  centered?: boolean
  productPage?: boolean
}>

const SideScrollable: React.FC<Props> = ({ children, className, centered, productPage }) => {
  return (
    <div
      className={cx(
        styles.SideScrollable,
        className,
        { [styles.Centered]: centered },
        { [styles.productPage]: productPage },
      )}
    >
      {children}
    </div>
  )
}

export default SideScrollable
